import { MaterialFileFormFields } from "@/components/commonFormItems/MaterialFileFormFields";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import type { SourcingRequirementApplicationFormFields } from "../type";
import styles from "@/asserts/styles/formSection.module.less";
import { useWatchProductionMaterial } from "../hooks/useWatchProductionMaterial";
import { useFormEditable } from "../hooks/useFormEditable";

export function AttachmentFileFormFields() {
  const { isProductionMaterial } = useWatchProductionMaterial();
  const { isStartedEditable } = useFormEditable();

  const hiddenRemove = !isStartedEditable;

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title="相关附件" />

      <div className={styles.sectionBody}>
        {isProductionMaterial ? (
          <>
            <MaterialFileFormFields<SourcingRequirementApplicationFormFields>
              label="现有标准物料文件"
              fieldName="standardMaterialFiles"
              hiddenRemove={hiddenRemove}
            />
            <MaterialFileFormFields<SourcingRequirementApplicationFormFields>
              label="现有供应商COA"
              fieldName="coaFiles"
              hiddenRemove={hiddenRemove}
            />
          </>
        ) : (
          <>
            <MaterialFileFormFields<SourcingRequirementApplicationFormFields>
              label="URS文件"
              fieldName="ursFiles"
              hiddenRemove={hiddenRemove}
            />
          </>
        )}

        <MaterialFileFormFields<SourcingRequirementApplicationFormFields>
          label="其他"
          fieldName="othersFiles"
          required={false}
          hiddenRemove={hiddenRemove}
        />
      </div>
    </div>
  );
}
